export const POST_DEVICE_COLOURS = '@@myDevices/postDeviceColours'
